import type { WellnessSlide } from '@lighthouse/shared';

interface Props {
  slide: WellnessSlide;
  className?: string;
  priority?: boolean;
}

export function WellnessSlidePhoto({ slide, className = '', priority = false }: Props) {
  const [c1, c2] = slide.gradient;

  return (
    <div
      className={`wellness-slide-photo ${className}`}
      style={{ background: `linear-gradient(135deg, ${c1}, ${c2})` }}
    >
      <img
        src={slide.imageUrl}
        alt=""
        className="wellness-slide-photo-img"
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
        draggable={false}
        referrerPolicy="no-referrer"
      />
    </div>
  );
}
